import { atom } from "recoil";

export const ConnectionModalOpened = atom<boolean>({
  key: "connectionModalOpened",
  default: false,
});
